import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { authService } from '../../services/authService';
import { Icon } from '../ui';

interface Props {
  onClose: () => void;
}

/**
 * Das eigene Passwort ändern — erreichbar für jeden Benutzer über das Menü unten in der
 * Seitenleiste. Bis 10/2026 ging das nur über einen Administrator.
 */
const PasswordChangeForm: React.FC<Props> = ({ onClose }) => {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [repeat, setRepeat] = useState('');
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (newPassword.length < 6) {
      toast.error('Das neue Passwort muss mindestens 6 Zeichen lang sein');
      return;
    }
    if (newPassword !== repeat) {
      toast.error('Die beiden neuen Passwörter stimmen nicht überein');
      return;
    }
    try {
      setSaving(true);
      await authService.changeOwnPassword({ oldPassword, newPassword });
      toast.success('Passwort geändert');
      onClose();
    } catch (error) {
      toast.error((error as Error).message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="form-overlay">
      <div className="form-modal">
        <div className="form-header">
          <h2>Passwort ändern</h2>
          <button className="form-close" onClick={onClose} aria-label="Schließen"><Icon.Close size={18} /></button>
        </div>
        <form onSubmit={handleSubmit} className="form-body">
          <div className="form-grid">
            <div className="form-group form-group-full"><label className="form-label">Aktuelles Passwort</label>
              <input className="form-control" type="password" autoComplete="current-password" required
                value={oldPassword} onChange={e => setOldPassword(e.target.value)} /></div>
            <div className="form-group"><label className="form-label">Neues Passwort</label>
              <input className="form-control" type="password" autoComplete="new-password" required
                value={newPassword} onChange={e => setNewPassword(e.target.value)} /></div>
            <div className="form-group"><label className="form-label">Neues Passwort wiederholen</label>
              <input className="form-control" type="password" autoComplete="new-password" required
                value={repeat} onChange={e => setRepeat(e.target.value)} /></div>
          </div>
          <p className="form-hint">Mindestens 6 Zeichen. Sie bleiben danach angemeldet.</p>
          <div className="form-actions">
            <button type="button" className="btn btn-secondary" onClick={onClose}>Abbrechen</button>
            <button type="submit" className="btn btn-primary" disabled={saving}>{saving ? 'Speichern…' : 'Passwort ändern'}</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PasswordChangeForm;
